import { SVGProps } from 'react';

export const StarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M6.21868 1.89471C6.32276 1.64447 6.67725 1.64447 6.78133 1.89471L7.9329 4.66341C7.97677 4.76891 8.07598 4.84099 8.18987 4.85012L11.1789 5.08975C11.4491 5.11141 11.5586 5.44855 11.3528 5.62486L9.07545 7.57565C8.98868 7.64997 8.95078 7.7666 8.97729 7.87774L9.67306 10.7945C9.73594 11.0582 9.44916 11.2665 9.21787 11.1253L6.65882 9.56221C6.56132 9.50265 6.43869 9.50265 6.34118 9.56221L3.78214 11.1253C3.55085 11.2665 3.26406 11.0582 3.32695 10.7945L4.02271 7.87774C4.04922 7.7666 4.01133 7.64997 3.92456 7.57565L1.64722 5.62486C1.44139 5.44855 1.55093 5.11141 1.82108 5.08975L4.81013 4.85012C4.92402 4.84099 5.02323 4.76891 5.06711 4.66342L6.21868 1.89471Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const StarIconFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}>
    <g clipPath='url(#clip0_210_62243)'>
      <path
        d='M8.49748 2.35937C8.64437 2.01563 9.14469 2.01563 9.29159 2.35937L10.9169 6.1626C10.9788 6.30751 11.1188 6.40652 11.2796 6.41906L15.4983 6.74823C15.8795 6.77798 16.0342 7.24109 15.7437 7.48328L12.5295 10.163C12.407 10.2651 12.3535 10.4253 12.3909 10.578L13.3729 14.5846C13.4617 14.9467 13.0569 15.233 12.7305 15.0389L9.11869 12.8918C8.98107 12.81 8.80799 12.81 8.67038 12.8918L5.0586 15.0389C4.73216 15.233 4.3274 14.9467 4.41615 14.5846L5.39814 10.578C5.43555 10.4253 5.38207 10.2651 5.2596 10.163L2.04541 7.48329C1.75491 7.24109 1.90952 6.77798 2.2908 6.74823L6.50949 6.41906C6.67023 6.40652 6.81025 6.30751 6.87218 6.1626L8.49748 2.35937Z'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_210_62243'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const StarIconHalfFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}>
    <g clipPath='url(#clip0_210_62245)'>
      <path
        d='M8.49748 2.35937C8.64437 2.01563 9.14469 2.01563 9.29159 2.35937L10.9169 6.1626C10.9788 6.30751 11.1188 6.40652 11.2796 6.41906L15.4983 6.74823C15.8795 6.77798 16.0342 7.24109 15.7437 7.48328L12.5295 10.163C12.407 10.2651 12.3535 10.4253 12.3909 10.5779L13.3729 14.5846C13.4617 14.9467 13.0569 15.233 12.7305 15.0389L9.11869 12.8918C8.98107 12.81 8.80799 12.81 8.67038 12.8918L5.0586 15.0389C4.73216 15.233 4.3274 14.9467 4.41615 14.5846L5.39814 10.5779C5.43555 10.4253 5.38207 10.2651 5.2596 10.163L2.04541 7.48329C1.75491 7.24109 1.90952 6.77798 2.2908 6.74823L6.50949 6.41906C6.67023 6.40652 6.81025 6.30751 6.87218 6.1626L8.49748 2.35937Z'
        fill='white'
        stroke='#5364D3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9 13V7.08679V2C9 2 7.91276 4.93387 6.66667 5.9564C4.91667 6.49999 2.19844 6.89463 2 7.08693C1.99998 7.65219 5.5 10.4781 5.5 10.4781C5.5 10.4781 4.33333 14.9539 4.91667 14.9997C5.25785 15.0265 7.25 14 9 13Z'
        fill='#5364D3'
      />
    </g>
    <defs>
      <clipPath id='clip0_210_62245'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
